// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"00bf0d96","371":"ebbf1212","928":"0a135f43"}[chunkId] + ".chunk.js";
};